/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_Focus_ValueInputs */

const en_landing_why_focus_value = /** @type {(inputs: Landing_Why_Focus_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-turn editing`)
};

const zh_landing_why_focus_value = /** @type {(inputs: Landing_Why_Focus_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多轮编辑`)
};

/**
* | output |
* | --- |
* | "Multi-turn editing" |
*
* @param {Landing_Why_Focus_ValueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_focus_value = /** @type {((inputs?: Landing_Why_Focus_ValueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_Focus_ValueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_focus_value(inputs)
	return zh_landing_why_focus_value(inputs)
});
export { landing_why_focus_value as "landing.why.focus_value" }